import * as React from 'react';
import { SVGProps } from 'react';

const IconRulerStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4h16v9H0V4Zm6 2h1v3h2V6h1v2h2V6h2v5H2V6h2v2h2V6Z"
    />
  </svg>
);
export default IconRulerStrokedSizeS;
